/**
 * Landing Page Router - Routes to organization-specific landing pages
 */

import { useEffect, useState } from 'react';
import IntelleSphereLanding from './IntelleSphereLanding';
import MavenBuilderLanding from './MavenBuilderLanding';
import DimentryLanding from './DimentryLanding';
import ZamdanLanding from './ZamdanLanding';

export default function Landing() {
  const [orgType, setOrgType] = useState<'intellesphere' | 'maven-builder' | 'dimentry' | 'zamdan' | null>(null);

  useEffect(() => {
    // Determine organization based on URL
    const hostname = window.location.hostname;
    
    // Check domain mapping
    if (hostname === 'diligent.intellesphere.com' || hostname.includes('intellesphere')) {
      setOrgType('intellesphere');
    } else if (hostname === 'builder.dimentry.com') {
      setOrgType('maven-builder');
    } else if (hostname === 'diligent.dimentry.com') {
      setOrgType('dimentry');
    } else if (hostname === 'diligent.zamdan.com') {
      setOrgType('zamdan');
    }
    else {
      // Check URL parameter
      const urlParams = new URLSearchParams(window.location.search);
      const orgParam = urlParams.get('org');
      
      if (orgParam === 'org_mavenbuilder') {
        setOrgType('maven-builder');
      } else if (orgParam === 'org_zamdan') {
        setOrgType('zamdan');
      } else if (orgParam === 'org_dimentry') {
        setOrgType('dimentry');
      } else if (orgParam === 'org_intellesphere') {
        setOrgType('intellesphere');
      } else {
        // Default to Intellesphere
        setOrgType('intellesphere');
      }
    }
  }, []);

  // Show loading state while determining organization
  if (!orgType) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-muted/40">
        <div className="text-center">
          <div className="w-16 h-16 border-4 border-primary/40 border-t-transparent rounded-full animate-spin mx-auto mb-4"></div>
          <p className="text-muted-foreground">Loading...</p>
        </div>
      </div>
    );
  }

  // Route to appropriate landing page
  if (orgType === 'maven-builder') {
    return <MavenBuilderLanding />;
  }

  if (orgType === 'dimentry') {
    return <DimentryLanding />;
  }

  if (orgType === 'zamdan') {
    return <ZamdanLanding />;
  }

  // Default to Intellesphere
  return <IntelleSphereLanding />;
}